var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-box-content"},[(_vm.title || _vm.$slots.title)?_c('div',{staticClass:"head-row"},[(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("title")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }